/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { CompanyTypeView } from './';
import {
    CompanyTypeViewFromJSON,
    CompanyTypeViewFromJSONTyped,
    CompanyTypeViewToJSON,
} from './';
import type { ComplianceFileType } from './';
import {
    ComplianceFileTypeFromJSON,
    ComplianceFileTypeFromJSONTyped,
    ComplianceFileTypeToJSON,
} from './';

/**
 * 
 * @export
 * @interface ComplianceResponse
 */
export interface ComplianceResponse {
    /**
     * 
     * @type {CompanyTypeView}
     * @memberof ComplianceResponse
     */
    companyType: CompanyTypeView;
    /**
     * 
     * @type {Array<ComplianceFileType>}
     * @memberof ComplianceResponse
     */
    mandatoryDocuments: Array<ComplianceFileType>;
}

/**
 * Check if a given object implements the ComplianceResponse interface.
 */
export function instanceOfComplianceResponse(value: object): value is ComplianceResponse {
    if (!('companyType' in value) || value['companyType'] === undefined) return false;
    if (!('mandatoryDocuments' in value) || value['mandatoryDocuments'] === undefined) return false;
    return true;
}

export function ComplianceResponseFromJSON(json: any): ComplianceResponse {
    return ComplianceResponseFromJSONTyped(json, false);
}

export function ComplianceResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ComplianceResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'companyType': CompanyTypeViewFromJSON(json['companyType']),
        'mandatoryDocuments': ((json['mandatoryDocuments'] as Array<any>).map(ComplianceFileTypeFromJSON)),
    };
}

export function ComplianceResponseToJSON(value?: ComplianceResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'companyType': CompanyTypeViewToJSON(value['companyType']),
        'mandatoryDocuments': ((value['mandatoryDocuments'] as Array<any>).map((v) => ComplianceFileTypeToJSON(v))),
    };
}

